import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'رابط',
    loadingWithEllipsis: 'جار التحميل...',
  },
  az: {
    label: 'Keçid',
    loadingWithEllipsis: 'Yüklənir...',
  },
  bg: {
    label: 'Връзка',
    loadingWithEllipsis: 'Зарежда се...',
  },
  cs: {
    label: 'Odkaz',
    loadingWithEllipsis: 'Načítání...',
  },
  da: {
    label: 'Link',
    loadingWithEllipsis: 'Indlæser...',
  },
  de: {
    label: 'Verknüpfung',
    loadingWithEllipsis: 'Laden...',
  },
  en: {
    label: 'Link',
    loadingWithEllipsis: 'Loading...',
  },
  es: {
    label: 'Enlace',
    loadingWithEllipsis: 'Cargando...',
  },
  et: {
    label: 'Link',
    loadingWithEllipsis: 'Laadimine...',
  },
  fa: {
    label: 'پیوند',
    loadingWithEllipsis: 'در حال بارگذاری...',
  },
  fr: {
    label: 'Lien',
    loadingWithEllipsis: 'Chargement...',
  },
  he: {
    label: 'קישור',
    loadingWithEllipsis: 'טוען...',
  },
  hr: {
    label: 'Poveznica',
    loadingWithEllipsis: 'Učitavanje...',
  },
  hu: {
    label: 'Hivatkozás',
    loadingWithEllipsis: 'Betöltés...',
  },
  is: {
    label: 'Hlekkur',
    loadingWithEllipsis: 'Hleð...',
  },
  it: {
    label: 'Collegamento',
    loadingWithEllipsis: 'Caricamento...',
  },
  ja: {
    label: 'リンク',
    loadingWithEllipsis: '読み込み中...',
  },
  ko: {
    label: '링크',
    loadingWithEllipsis: '로딩 중...',
  },
  my: {
    label: 'လင့်',
    loadingWithEllipsis: 'ဖွင့်နေသည်...',
  },
  nb: {
    label: 'Lenke',
    loadingWithEllipsis: 'Laster...',
  },
  nl: {
    label: 'Link',
    loadingWithEllipsis: 'Laden...',
  },
  pl: {
    label: 'Łącze',
    loadingWithEllipsis: 'Ładowanie...',
  },
  pt: {
    label: 'Ligação',
    loadingWithEllipsis: 'Carregando...',
  },
  ro: {
    label: 'Legătură',
    loadingWithEllipsis: 'Se încarcă...',
  },
  rs: {
    label: 'Веза',
    loadingWithEllipsis: 'Учитавање...',
  },
  'rs-latin': {
    label: 'Veza',
    loadingWithEllipsis: 'Učitavanje...',
  },
  ru: {
    label: 'Ссылка',
    loadingWithEllipsis: 'Загрузка...',
  },
  sk: {
    label: 'Odkaz',
    loadingWithEllipsis: 'Načítava sa...',
  },
  sl: {
    label: 'Povezava',
    loadingWithEllipsis: 'Nalaganje...',
  },
  sv: {
    label: 'Länk',
    loadingWithEllipsis: 'Laddar...',
  },
  ta: {
    label: 'இணைப்பு',
    loadingWithEllipsis: 'போர்த்துவருகிறது...',
  },
  th: {
    label: 'ลิงค์',
    loadingWithEllipsis: 'กำลังโหลด...',
  },
  tr: {
    label: 'Bağlantı',
    loadingWithEllipsis: 'Yükleniyor...',
  },
  uk: {
    label: 'Посилання',
    loadingWithEllipsis: 'Завантаження...',
  },
  vi: {
    label: 'Liên kết',
    loadingWithEllipsis: 'Đang tải...',
  },
  zh: {
    label: '链接',
    loadingWithEllipsis: '加载中...',
  },
  'zh-TW': {
    label: '連結',
    loadingWithEllipsis: '載入中...',
  },
}
